import React from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from './Footer';
import logoImage from '../assets/Logo.png';
import './CybersecurityTimeline.css';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import translations from '../translations';

const CybersecurityTimeline = () => {
    const navigate = useNavigate();
    const { lang } = useLanguage();
    const t = translations[lang];
    const isRTL = lang === 'ar';

    const handleHeaderClick = () => {
        navigate('/');
    };

  return (
    <div className="bg-[#111820] text-[#97d700] font-sans leading-normal tracking-normal" dir={isRTL ? 'rtl' : 'ltr'}>
      <Helmet>
        <title>{t.cyber_title}</title>
        <meta name="description" content={t.cyber_desc} />
      </Helmet>
      <div className="video-header" onClick={handleHeaderClick}>
        <video autoPlay loop muted className="background-video">
          <source src="/assets/cybernet.mp4" type="video/mp4" />
        </video>
        <div className="overlay"></div>
        <div className="header-content">
          <img src={logoImage} alt="Technology Resources Logo" className="header-logo" />
          <h1 className="header-title font-magistral">Tech Resources</h1>
        </div>
      </div>
      <div className={`timeline-container mx-auto text-center py-10 ${isRTL ? 'font-arabic' : ''}`}>
        <h1 className="timeline-title">{t.cyber_heading}</h1>
        <div className="timeline">
          {t.cyber_events.map((event) => (
            <div className="timeline-event" key={event.year}>
              <h2>{event.year}</h2>
              {event.text && <p>{event.text}</p>}
              {event.details && (
                <ul>
                  {event.details.map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CybersecurityTimeline;
